export default __webpack_public_path__ + "static/media/person-icon-green-img.b901eb18.svg";